import client from '../client'

export default {
  // 初期表示
  FirstDisplay: param => {
    return new Promise((resolve, reject) => {

      var url = 'api/AdminReserveStatusCheck/AdminReserveStatusCheckFirstDisplay'

      var qs = require('qs')
      var data = qs.stringify({
        ircd: param.ircd,
      })

      var config = {
        method: 'post',
        url: url,
        headers: {
          'Authorization': 'Bearer ' + param.token,
        },
        data: data
      };

      client(config)
        .then(responce => {
          // WebApiからのレスポンスをそのまま戻り値（プロミス）で返す
          resolve({
            responce: responce
          })
        })
        .catch(err => {
          console.log(err)
          reject()
        })
    })
  },
  // 予約状況欄の枠ごとの集計結果取得
  SearchSummaryResults: param => {
    return new Promise((resolve, reject) => {

      var url = 'api/AdminReserveStatusCheck/AdminReserveStatusCheckSearchSummaryResults'
      var qs = require('qs')
      var data = qs.stringify({
        ircd: param.ircd,
        // 予約登録日
        crdyStYear: param.crdyStYear,
        crdyStMonth: param.crdyStMonth,
        crdyStDate: param.crdyStDate,
        crdyEdYear: param.crdyEdYear,
        crdyEdMonth: param.crdyEdMonth,
        crdyEdDate: param.crdyEdDate,
        // 予約更新日
        updyStYear: param.updyStYear,
        updyStMonth: param.updyStMonth,
        updyStDate: param.updyStDate,
        updyEdYear: param.updyEdYear,
        updyEdMonth: param.updyEdMonth,
        updyEdDate: param.updyEdDate,
        // 受診日
        ykdyStYear: param.ykdyStYear,
        ykdyStMonth: param.ykdyStMonth,
        ykdyStDate: param.ykdyStDate,
        ykdyEdYear: param.ykdyEdYear,
        ykdyEdMonth: param.ykdyEdMonth,
        ykdyEdDate: param.ykdyEdDate,
      })

      var config = {
        method: 'post',
        url: url,
        headers: {
          'Authorization': 'Bearer ' + param.token,
        },
        data: data
      };

      client(config)
        .then(responce => {
          // WebApiからのレスポンスをそのまま戻り値（プロミス）で返す
          resolve({
            responce: responce
          })
        })
        .catch(err => {
          console.log(err)
          reject()
        })
    })
  },
  // カレンダーの月変更処理
  ChangeCalender: param => {
    return new Promise((resolve, reject) => {

      var url = 'api/AdminReserveStatusCheck/AdminReserveStatusCheckChangeCalender'
      var qs = require('qs')
      var data = qs.stringify({
        ircd: param.ircd,
        // カレンダーに表示する年、月（整数値）
        calenderYear: param.calenderYear,
        calenderMonth: param.calenderMonth
      })

      var config = {
        method: 'post',
        url: url,
        headers: {
          'Authorization': 'Bearer ' + param.token,
        },
        data: data
      };

      client(config)
        .then(responce => {
          // WebApiからのレスポンスをそのまま戻り値（プロミス）で返す
          resolve({
            responce: responce
          })
        })
        .catch(err => {
          console.log(err)
          reject()
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/Admin/AdminReserveStatusCheckApi.js